import { render } from "./ChatEmptyView.vue?vue&type=template&id=216bc57e"
const script = {}

import "./ChatEmptyView.vue?vue&type=style&index=0&id=216bc57e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__